import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { applicationPaths, localStorageKeys } from '../../../../Models/configurations';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { UtilityServices } from './../../../../Services/utility.services';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent implements OnInit, AfterViewInit {
  urlName: string;
  dealerId: string;
  customerDetail: any;
  vehicleDetail: any;
  licensePlateClass:string;

  constructor(
    private readonly utilityService: UtilityServices,
    private readonly secureStorageService: SecureStorageService,
    private readonly spinner: NgxSpinnerService,
    private readonly globalSetting:GlobalSetting
  ) {
    this.urlName = '/' + applicationPaths.first;
  }

  public moveNext() {
    this.utilityService.navigateToNext(this.urlName);
  }

  public populateVehicleDetails(): void {
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)) !== 'undefined') {
      this.vehicleDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail;
      this.customerDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).customerDetail;
      this.spinner.hide();
    } else {

      this.spinner.hide();
    }
  }

  ngOnInit(): void {
    this.licensePlateClass=this.globalSetting.getGlobalLicencePlate();
    let autoCarPlate = this.secureStorageService.getKeyData(localStorageKeys.autoCarPlate);
    if (autoCarPlate) {
      this.moveNext();
    }
    this.secureStorageService.removeKey(localStorageKeys.autoCarPlate);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.spinner.show();
      this.populateVehicleDetails();
    }, 500);
  }
}
